// src/pages/ErrorPage.tsx
import React from 'react';

interface ErrorPageProps {
  errorCode?: number;
  errorMessage?: string;
  apiPath?: string;
  status?: string;
}

const ErrorPage: React.FC<ErrorPageProps> = ({
  errorCode = 404,
  errorMessage = '你访问的页面不存在',
  apiPath = window.location.pathname,
  status = 'fail',
}) => {
  return (
    <div style={{ padding: 48, textAlign: 'center' }}>
      <h1>错误：{errorCode}</h1>
      <p style={{ fontSize: 18, color: '#ff4d4f', margin: '16px 0' }}>
        {errorMessage}
      </p>
      <div style={{ marginBottom: 12 }}>
        <strong>API 路径：</strong>{apiPath}
      </div>
      <div>
        <strong>状态码：</strong>{errorCode}
      </div>
      <div>
        <strong>状态：</strong>{status}
      </div>
    </div>
  );
};

export default ErrorPage;
